import { intl } from 'ehs-react';
import React from 'react';

export function Header(): React.JSX.Element {
  return (
    <>
      <h1 className="header">{intl('checkaccessportlet.view.title')}</h1>
      <p className="description">{intl('checkaccessportlet.view.subtitle')}</p>
    </>
  );
}
